import { WeaTools } from 'ecCom'

export const getFormField = (params) => {
    return WeaTools.callApi('/api/hrm/roleset/getHrmRoleSetForm', 'GET', params);
}

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/roleset/getSearchResult', 'POST', params);
}

export const saveFormFields = (params) => {
    return WeaTools.callApi('/api/hrm/roleset/save', 'POST', params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/roleset.js